import { Box, Stack } from '@mui/material'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function TimeWindows(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.timeWindows.label}>
      {extOrder.orderStep.timeWindows.length === 0 ? (
        <preview.NullValue />
      ) : (
        <Stack spacing={0.5}>
          {extOrder.orderStep.timeWindows.map((tw, index) => (
            <Box key={`tw_${index}`}>
              <preview.TimeWindow tw={tw} />
            </Box>
          ))}
        </Stack>
      )}
    </preview.Field>
  )
}
